export default __webpack_public_path__ + "static/article-the-reality-of-work-and-travel-cape-town-f3d9a975bcb69bd11a81e4f5396d16d3.jpg";